module.exports = __webpack_public_path__ + "static/media/img3-1.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/CA/img3-1.png
// module id = 1918
// module chunks = 3